import _ from "@lodash";
import AppContext from "app/AppContext";
import history from "history.js";
import queryString from "query-string";
import React, { Component } from "react";
import { connect } from "react-redux";
import { matchRoutes } from "react-router-config";
import { withRouter } from "react-router-dom";

const RotasDefault = ["/", "/pub-login", "/token", "/pub-logout", "/pub-organizacao", "/pub-register", "/pub-reset-password", "/pub-confirmar-email", "/error", "/atualizando", "/help", "/faq", "/minhastarefas/solicitacoes/", "/solicitar-teste", "/solicitar-empresa", "/homolog"];

class FuseAuthorization extends Component {

    constructor(props, context) {
        super(props);
        const { routes } = context;
        this.state = {
            logged: false,
            accessGranted: false,
            routes
        };
    }

    componentDidMount() {
        try {
            if (!this.state.accessGranted) {
                console.log("not access granted");
                this.redirectRoute(this.props);
            }
        }
        catch (ex) {
            alert(ex);
        }
    }

    componentDidUpdate() {
        if (!this.state.accessGranted) {
            console.log("not access granted");
            this.redirectRoute(this.props);
        }
    }

    static getDerivedStateFromProps(props) {
        const { location, user = null } = props;
        const { pathname, search } = location;
        let accessGranted = false;
        let logged = false;
        let key = "user";
        let matched;

        if (search.includes("ctx=") && !_.isEqual(queryString.parse(search).ctx, sessionStorage.getItem("ctx"))) {
            sessionStorage.setItem("ctx", queryString.parse(search).ctx);
        }

        if (!_.isNull(user) && pathname.split("/").length > 3 && user.data.settings && user.data.settings.route && user.data.settings.route[pathname.split("/")[2]]) {
            key = pathname.split("/")[2];
        }

        if (RotasDefault.includes(pathname.split("?")[0])) {
            accessGranted = true;
        }
        else if (!_.isNull(user) && !_.isNull(user.data.settings) && Object.keys(user.data.settings).length > 0) {
            logged = true;
            if (pathname.includes("/vincularcomchave")) {
                accessGranted = true;
            }
            else if (!_.isNull(user.data.settings.route) && user.data.settings.route[key] && matchRoutes(user.data.settings.route[key], pathname) !== undefined) {
                matched = matchRoutes(user.data.settings.route[key], pathname)[0];
                accessGranted = ((matched) && (matched.match.isExact)) ? true : false;
            }
        }

        if (accessGranted && props.rollback !== pathname) {
            sessionStorage.setItem("rollback", props.rollback);
        }

        return {
            accessGranted,
            logged
        };
    }

    shouldComponentUpdate(nextProps, nextState) {
        return nextState.accessGranted !== this.state.accessGranted;
    }

    redirectRoute(props) {
        const { logged } = this.state;
        const { location } = props;
        const { pathname } = location;
        var redirectUrl = "/pub-login";

        if (pathname !== undefined && pathname !== null && !RotasDefault.includes(pathname.split("?")[0])) {
            redirectUrl = redirectUrl + "?q=" + pathname;
        }

        if (logged) {
            history.push("/home");
        }
        else {
            document.location.href = redirectUrl;
        }
    }

    render() {
        const { children } = this.props;
        const { accessGranted } = this.state;
        return accessGranted ? <React.Fragment>{children}</React.Fragment> : null;
    }
}



function mapStateToProps({ auth }) {
    return {
        user: auth.user,
        rollback: document.location.pathname
    };
}

FuseAuthorization.contextType = AppContext;

export default withRouter(connect(mapStateToProps)(FuseAuthorization));
